import { render, staticRenderFns } from "./SocialFacebook.vue?vue&type=template&id=17b2787b&scoped=true"
import script from "./SocialFacebook.vue?vue&type=script&lang=js"
export * from "./SocialFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2787b",
  null
  
)

export default component.exports